import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@/lib/utils";

/** `compact` is a field inside a popover or a dense row; `prefixed` leaves room for a symbol drawn over its left edge (the £ of an amount). */
function Input({
  className,
  type,
  compact = false,
  prefixed = false,
  ...props
}: React.ComponentProps<"input"> & { compact?: boolean; prefixed?: boolean }) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        // The placeholder token: a watermark must read as clearly secondary to an entered value.
        "h-10 w-full min-w-0 rounded-lg border border-input bg-field px-3 py-0 text-body-tight transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-body-tight file:font-medium file:text-foreground placeholder:text-placeholder focus-visible:border-foreground/60 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-50 aria-invalid:border-warning aria-invalid:focus-visible:outline-1 aria-invalid:focus-visible:outline-solid aria-invalid:focus-visible:outline-warning/40 dark:disabled:bg-foreground/12",
        compact && "h-8 text-small",
        prefixed && "pl-7",
        className
      )}
      {...props}
    />
  );
}

export { Input };
